import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const year = new Date().getFullYear();

export const Footer = () => {
  return (
    <footer className="bg-charcoal text-white" data-testid="site-footer">
      <div className="container-rozier py-14 md:py-16">
        <div className="flex flex-col md:flex-row flex-wrap justify-between gap-10 md:gap-12">
          {/* Logo + signature */}
          <div className="md:max-w-[260px]">
            <div className="flex items-baseline gap-2 mb-5">
              <span className="font-serif italic text-3xl gold-text-shimmer leading-none">
                Rozier
              </span>
              <span className="font-sans uppercase tracking-[0.32em] text-[11px] text-white/80">
                Concept
              </span>
            </div>
            <p className="font-serif italic text-2xl md:text-[28px] leading-snug font-light">
              L'invisible <span className="gold-text-shimmer">structure</span> le
              visible.
            </p>
          </div>

          {/* Catchline + CTA */}
          <div className="md:max-w-[320px]">
            <p className="text-white/75 text-[14px] leading-[1.8]">
              Particuliers, professionnels. Construction neuve, rénovation, terrain
              vierge ou bâti ancien. Posons ensemble les bases d'un lieu harmonieux.
            </p>
            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-3 border border-white/30 text-white px-6 py-3 uppercase tracking-[0.28em] text-[11px] hover:border-gold hover:text-gold transition-colors duration-300 group"
              data-testid="footer-cta-contact"
            >
              Parlons de votre projet
              <ArrowUpRight
                size={12}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </Link>
          </div>

          {/* Nota */}
          <div className="md:max-w-[320px]">
            <p className="overline text-white/50 mb-3">Nota</p>
            <p className="text-white/55 text-[12px] leading-[1.65]">
              Rozier Concept n'est ni architecte DPLG, ni maître d'œuvre, ni bureau
              d'études au sens réglementaire. Nous intervenons en amont et en
              parallèle des professionnels habilités, pour porter la vision globale
              et assurer la cohérence de votre projet de bout en bout.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="container-rozier py-5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[11px] text-white/40 tracking-wider order-2 md:order-1">
            © {year} Rozier Concept. Tous droits réservés.
          </p>

          <div className="flex items-center gap-6 order-1 md:order-2">
            <Link
              to="/mentions-legales"
              className="text-[11px] text-white/55 hover:text-gold tracking-wider transition-colors"
              data-testid="footer-link-mentions-legales"
            >
              Mentions légales
            </Link>
            <span className="text-white/20 text-[11px]">·</span>
            <Link
              to="/politique-de-confidentialite"
              className="text-[11px] text-white/55 hover:text-gold tracking-wider transition-colors"
              data-testid="footer-link-confidentialite"
            >
              Politique de confidentialité
            </Link>
          </div>

          <p className="text-[11px] text-white/40 tracking-wider order-3">
            Site conçu et réalisé par{" "}
            <a
              href="https://axeris-labs.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-gold transition-colors"
              data-testid="footer-link-axeris"
            >
              Axeris Labs
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
